import { render, staticRenderFns } from "./UiSpinner.vue?vue&type=template&id=cc62504c&scoped=true&lang=pug"
import script from "./UiSpinner.vue?vue&type=script&lang=js"
export * from "./UiSpinner.vue?vue&type=script&lang=js"
import style0 from "./UiSpinner.vue?vue&type=style&index=0&id=cc62504c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc62504c",
  null
  
)

export default component.exports